import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Helmet } from "react-helmet-async";

import { FeatureHighlights } from "./FeatureHighlights";
import { SignUpForm } from "./SignUpForm";

const canonicalUrl = "/join-us/";
const title = "Join Us | Pre-Reg Shortcuts";
const metaDescription =
  "Need to revise for your Pharmacy or GPhC exam and not sure where to begin? Join us now with free exam revision resources. Preview our courses including our designated supervisor programme.";
const metaKeywords =
  "pharmacy training, trainee pharmacist, foundation training, Oriel support, BNF calculations, MEP course, OTC course, designated supervisor programme, pharmacy students, GPhC exam revision, pre-reg pharmacist, pharmacy career support";

const gridSx = {
  px: { xs: 0, md: 3 },
  py: { xs: 3, md: 0 },
};

const borderSx = {
  borderRight: { xs: 0, md: "1px solid #e0e0e0" },
  borderBottom: {
    xs: "1px solid #e0e0e0",
    md: 0,
  },
};

const SignUpPage = () => {
  return (
    <>
      <Helmet link={[{ rel: "canonical", href: canonicalUrl }]}>
        <title>{title}</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>

      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Grid container>
          <Grid item xs={12} md={4} sx={{ ...borderSx, ...gridSx }}>
            <SignUpForm />
          </Grid>
          <Grid item xs={12} md={8} sx={gridSx}>
            <FeatureHighlights />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export { SignUpPage };
